import React from 'react';
import { useCache } from '../../state/CachingContext';
import Enter2FACode from '../Shared/Enter2FACode';

const TwoFACheck = (): JSX.Element => {
  const { getCache } = useCache();
  const invitationguid = getCache('invitationguid');

  return <Enter2FACode internalRedirectTo={invitationguid && '/Auth/ConfirmInvitation'} />;
};

export default TwoFACheck;
